export const airPriceWatchGetListQuery = `
query airPriceWatchGetListResponse($input: AirPriceWatchGetListRequest) {
  airPriceWatchGetListResponse(input: $input) {
      priceWatches {
        watchId
        active
        originCityId
        destCityId
        originAbbreviation
        destAbbreviation
        departDate
        returnDate
        dealPrice
        lastNotifiedPrice
        dealType
        tripType
        appCode
        createdDateTime
        lastNotifiedDateTime
      }
      status
      statusCode
      statusMessage
      email
      version
      error {
        type
        code
        desc
        message
        reason
        reason_code
      }
  }
}
`
